import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';
import styles from './ResetPassword.styles';
import { resetPasswordAction,verifyPasswordTokenAction } from '../../reducers/actions';
import ResetPasswordForm from '../../components/forms/resetpassword/ResetPasswordForm';
import logo from '../../assets/logo_white.png';
import Image from '../../components/common/image/Image';

export class ResetPassword extends Component {
  state = {
    email: null,
    token: null
  };
  onSubmit = values => {
    let p = values.password;
    let {token, email } = this.state;
    this.props.resetPasswordAction(email, token, p);
  };
  email = null
  token = null
  locationParams(){
    try{
      let s = new URLSearchParams(document.location.search)
      return {
        email: s.get('email'),
        token: s.get('key')
      }
    }catch(e){
      console.log('issue parsing search params')
      return {}
    }
      
  }
  componentDidMount(){
    let o = this.locationParams()
    this.setState(o)
    if(o.email && o.token){
      this.props.verifyToken(o.email,o.token)
    }
  }
  render() {
    let obj = (<ResetPasswordForm email={this.state.email} token={this.state.token} 
      error={this.state.error}
      onSubmit={this.onSubmit} />) 
    if(!this.state.email || !this.state.token){
      obj = (<div className={css(styles.outline)}>
      <Image src={logo} alt="logo" styles={styles.logo} />
      <div className={css(styles.msg)}><p>{I18n.t('newuser.invalidParameters')}</p>
        </div>
      </div>)
    }
    if(!this.props.tokenValid){
      obj = (<div className={css(styles.outline)}>
      <Image src={logo} alt="logo" styles={styles.logo} />
      <div className={css(styles.msg)}><p>{I18n.t('resetPassword.invalidToken')}</p>
      <Link to="/forgot" className={css(styles.link)}>
          {I18n.t('resetPassword.forgotPasswordTxt')}      
        </Link>
        </div>
      </div>)
    }
    if(this.props.resetPasswordCompleted){
      obj = (<div className={css(styles.outline)}>
      <Image src={logo} alt="logo" styles={styles.logo} />
      <div className={css(styles.msg)}><p>{I18n.t('resetPassword.success')}</p>
      <Link to="/login" className={css(styles.link)}>
          {I18n.t('login.login')}      
        </Link>
      </div>
      </div>)
    }
    return (
      <div className={css(styles.base)}>
      {obj}
      </div>
    );
  }
}

const mapStateToProps = ({auth}) => {
  let resetPasswordCompleted = auth.resetPasswordCompleted;
  let tokenValid = auth.tokenValid;
  return { resetPasswordCompleted, tokenValid };
};

const mapDispatchToProps = dispatch => {
  return {
    resetPasswordAction() {
      dispatch(resetPasswordAction(...arguments));
    },
    verifyToken(){
      dispatch(verifyPasswordTokenAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/containers/resetpassword/ResetPassword.js